"use client";

import { Box, styled } from "@mui/material";

const Section = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    "&:nth-child(even)": {
      backgroundColor: "grey.100",
    },
  })
);

export default Section;